import { useContext, useState } from "react";

import { StyleSheet, View, Text, ImageBackground } from "react-native";
import SafeAreaView from "../components/SafeAreaView";

//import MaterialIcons from "react-native-vector-icons/MaterialIcons";
//import Ionicons from "react-native-vector-icons/Ionicons";

import { MaterialIcons } from "../components/VectorIcons";
import { Ionicons } from "../components/VectorIcons";
//import { TextInput } from "react-native-gesture-handler";

//import LoginSVG from "../assets/images/misc/login.svg";
import CustomButton from "../components/CustomButton";
import InputField from "../components/InputField";
import { AuthContext } from "../context/AuthContext";
import InfoField from "../components/InfoField";
import { topLogin, ChipType, getSchemeStyle } from "../context/helper";

const LoginScreen = ({ navigation }) => {
  const schemeStyles = getSchemeStyle();

  const { login, isService, serviceBoardInfo } = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [resultText, setResultText] = useState("");

  const titleText = () => (isService ? "Login Servicebereich" : "Login");
  const adminOnly = () => serviceBoardInfo && serviceBoardInfo.firmid == 0;
  const BoardInfo = () => {
    return (
      <View style={styles.boardInfoContainer}>
        <Text style={[styles.boardInfoHeader,schemeStyles.defaultText]}>
          {serviceBoardInfo
            ? `Sensorbox-ID: #${serviceBoardInfo.id}`
            : `Keine Sensorboxdaten gefunden`}
        </Text>
        {serviceBoardInfo && (
          <Text style={[styles.boardInfoBody,schemeStyles.defaultText]}>{`Chip-Typ: ${ChipType.chipName(
            serviceBoardInfo.chiptype
          )}`}</Text>
        )}

        {adminOnly() && (
          <Text style={[styles.boardInfoAdminHint,schemeStyles.adminInfoText]}>
            Die Sensorbox ist keinem Unternehmen zugeordet. Anmeldung nur als
            Administrator.
          </Text>
        )}
      </View>
    );
  };

  return (
    /*         <View style={styles.imageContainer}>
          <LoginSVG
            height={300}
            width={300}
            style={{ transform: [{ rotate: "-5deg" }] }}
          />
        </View>
 */
    <SafeAreaView style={[styles.mainArea,schemeStyles.Background]}>
      <View style={styles.spaceView}>
        <View style={styles.mainContainer}>
          <View style={styles.imageMainContainer}>
            <View style={styles.spaceView}></View>
            <View style={styles.imageContainer}>
              <ImageBackground
                source={require("../assets/images/sencono-logo-256.png")}
                style={styles.mainImage}
              />
            </View>
          </View>
          <Text style={[styles.titleText,schemeStyles.grayText]}>{titleText()}</Text>
          {isService && <BoardInfo />}
          <InputField
            style={[styles.inputField,schemeStyles.BorderC,schemeStyles.defaultText,schemeStyles.placeholderText]}
            label={"Loginname"}
            icon={
              <MaterialIcons name="person-outline" size={24} color={schemeStyles.grayIcon.color} />
            }
            value={username}
            onChangeText={(text) => {
              setResultText("");
              setUsername(text);
            }}
          />
          <InputField
            style={[styles.inputField,schemeStyles.BorderC,schemeStyles.defaultText,schemeStyles.placeholderText]}
            label={"Kennwort"}
            icon={
              <Ionicons name="lock-closed-outline" size={24} color={schemeStyles.grayIcon.color} />
            }
            inputType={"password"}
            value={password}
            onChangeText={(text) => {
              setResultText("");
              setPassword(text);
            }}
          />
          <View style={styles.resultContainer}>
            <Text style={schemeStyles.resultText}>{resultText}</Text>
          </View>
          <CustomButton
              style={[schemeStyles.buttonText]}
              disabled={
              !(username && password && (!isService || serviceBoardInfo))
            }
            onPress={() => {
              console.log(isService);
              console.log(serviceBoardInfo?.firmid);
              setResultText("");
              login(username, password, isService, serviceBoardInfo?.firmid)
                .then((msg) => {
                  //console.log("Login OK");
                })
                .catch((e) => {
                  setResultText(e.reason);
                  setPassword("");
                });
            }}
          >
            Anmelden
          </CustomButton>
          {!isService && (
            <CustomButton
              style={[styles.guestButton,schemeStyles.buttonText]}
              onPress={() => {
                setResultText("");
                login("TestUser", "SenConoTest$4")
                  .then((msg) => {
                    //console.log("Login OK");
                  })
                  .catch((e) => {
                    setResultText(e.reason);
                  });
              }}
            >
              Als Gast anmelden
            </CustomButton>
          )}
        </View>
        {!isService && (
          <InfoField
            style={{ marginTop: 10 }}
            label={"Für den Live Testzugang als GAST anmelden!"}
          />
        )}
      </View>
    </SafeAreaView>
  );
};

/* <View style={styles.guestInfoContainer}>
<View style={styles.guestInfoContent}>
  <Ionicons
    name="information-circle-outline"
    size={24}
    color="#666"
  />
  <Text style={styles.guestInfoText}>
    Für den Live Testzugang als GAST anmelden!
  </Text>
</View>
</View>
 */

export default LoginScreen;

const styles = StyleSheet.create({
  mainArea: {
    flex: 1,
  },
  mainContainer: {
    flex: 1,
    justifyContent: topLogin() ? "flex-start" : "center",
    paddingHorizontal: 25,
    marginTop: topLogin() ? 80 : 0,
  },
  imageMainContainer: {
    flexDirection: "row",
  },
  imageContainer: {
    alignItems: "center",
    flex: 2,
  },
  spaceView: {
    flex: 1,
  },
  mainImage: {
    width: 150,
    height: 150,
  },
  titleText: {
    fontFamily: "Roboto-Medium",
    fontSize: 28,
    fontWeight: "500",
    marginBottom: 30,
  },
  inputField: {
    fontFamily: "Roboto-Regular",
    fontSize: 20,
    marginBottom: 20,
  },
  guestButton: {
    backgroundColor: "#555",
  },
  resultContainer: {
    marginBottom: 10,
  },
  boardInfoContainer: { marginBottom: 20 },
  boardInfoHeader: {
    fontFamily: "Roboto-Regular",
    fontSize: 22,
  },
  boardInfoBody: {
    fontFamily: "Roboto-Regular",
    fontSize: 18,
  },
  boardInfoAdminHint: { marginTop: 5 },
});
